<template>
  <div id="publishing-journal-website-sections-import">
    <ipub-model title="Update XML"
                width="400px"
                :showFooter="false"
                :visable="isVisable"
                @cancel="cancel">
      <ipub-progress class="mar-b-10"
                     :progress="progress.progress"
                     :title="progress.status"
                     :type="progress.status" />
      <div v-if="progress.status==='PROCESSING'">
        <font class="warning-color">
          <ipub-icon type="iconDetails" />
        </font>
        The system is updating XML. Do not exit!
      </div>
      <div v-else-if="progress.status==='SUCCESS'">
        <font class="success-color">
          <ipub-icon type="iconAble" />
        </font>
        Update successfully!
      </div>
      <div v-else-if="progress.status==='FAILURE'">
        <font class="key-color">
          <ipub-icon type="iconDisable" />
        </font>
        Partial update failed！
        <div>
          Failure Information：<a class="link-color"
             :href="`${domain}/${progress.msg}`">Click here to download.</a>
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import article from '@/api/article'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
    })
  },
  watch: {
    async isVisable (val) {
      if (!val) {
        this.clear()
      } else {
        this.getProgress()
      }
    }
  },
  data () {
    return {
      params: '',
      progressId: '',
      file: '',
      progress: {
        progress: 0,
        status: 'PROCESSING'
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    clear () {
      this.progress = {}
      this.progressId = ''
      this.params = ''
      this.file = ''
    },
    async getProgress () {
      setTimeout(async () => {
        this.progress = await article.getProgress(this.inputData.id)
        if (this.progress.status === 'PROCESSING') {
          this.getProgress()
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
#publishing-journal-website-sections-import {
  .upload-content {
    background: $body_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    padding: 20px;
    text-align: center;
  }
}
</style>
